import { reactive, computed } from 'vue';
import EventReplaySessionsItem
  from '@/components/events/blocks/event-replay-sessions-item/event-replay-sessions-item.vue';

export default {
  name: 'EventReplaySessionsColumnComponent',
  props: {
    sessions: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    bgColor: {
      type: String,
      required: false,
      default: '#FFA400',
    },
    columns: {
      type: Number,
      required: false,
      default: 1,
    },
    dayColumns: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: { EventReplaySessionsItem },
  emits: ['play'],
  setup(props) {

    const state = reactive({
      sessions: props.sessions,
      headerStyle: computed(() => {
        return {
          "background": props.dayColumns ? 'inherit' : props.bgColor,
        }
      }),
    });

    return { state };
  },
  methods: {
    playVideo: async function(token) {
      this.$emit('play', token);
    }
  },
};
